import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams, useLocation, useHistory } from "react-router-dom";
import { useState } from "react";
import moment from "moment";
import Pagination from "../Pagination/Pagination";
import { dashboardQuestionerTotal, reminderApi, sentQuestionerDashboard } from "../../actions/riskManagement";
import './riskmanagementdashboard.css';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, isValid } from "date-fns";
import axios from "axios";
import { toastr } from 'react-redux-toastr';
import { API_URL } from "../../utils/constant";

const icons = {
  sent: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21.7 4.3L16.7 19.3C16.4 20.3 15 20.5 14.4 19.6L10.8 14.3L5.5 10.7C4.6 10.1 4.8 8.7 5.8 8.4L20.8 3.4C21.7 3 22.1 3.4 21.7 4.3Z" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10.8 14.3L21.7 4.3" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  unseen: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 4L20 20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M14 14.2361C13.4692 14.7111 12.7684 15 12 15C10.3431 15 9 13.6569 9 12C9 11.2316 9.28885 10.5308 9.76389 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M19.6078 15.6077C17.7796 17.1918 15.0167 18 12 18C7 18 3 12 3 12C3 12 5.01574 8.79334 8.11862 6.88862" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M21 12C21 12 20.1843 13.4367 18.8516 14.8516" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M12 9C13.6569 9 15 10.3431 15 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
  inReview: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="currentColor" strokeWidth="1.5" />
      <path d="M12 6V12L16 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  complete: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="currentColor" strokeWidth="1.5" />
      <path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  overdue: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="currentColor" strokeWidth="1.5" />
      <path d="M12 7V13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="12" cy="16" r="1" fill="currentColor" />
    </svg>
  ),
  search: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z" stroke="currentColor" strokeWidth="1.5" />
      <path d="M21 21L17 17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
  approved: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M20 7L12 4L4 7V11C4 14.3137 6.46819 18.4411 11.9999 20C17.5318 18.4411 20 14.3137 20 11V7Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
};


const RiskManagement = () => {
  const { orgId } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const id = useSelector((state) => orgId || state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id);
  const [page, setPage] = useState(1);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [search, setSearch] = useState('');
  const [totalItems, setTotalItems] = useState(1);
  const totalCount = useSelector((state) => state?.riskManagement?.totalDashboard?.data);
  const data = useSelector((state) => state?.riskManagement?.sentQuestionnaire);
  const [status, setStatus] = useState('');
  const [pageSize, setPageSize] = useState(10);

  // Add new state for the AI modal
  const [aiModalOpen, setAiModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadError, setUploadError] = useState("");

  // Add these near your other state variables
  const [resendModalOpen, setResendModalOpen] = useState(false);
  const [selectedQuestionnaire, setSelectedQuestionnaire] = useState(null);
  const [resendEmails, setResendEmails] = useState([]);
  const [newEmail, setNewEmail] = useState('');
  const [isResending, setIsResending] = useState(false);
  const [resendError, setResendError] = useState('');
  const [ids, setIds] = useState("");

  // Add state variables for due date update modal
  const [dueDateModalOpen, setDueDateModalOpen] = useState(false);
  const [selectedVendorId, setSelectedVendorId] = useState(null);
  const [newDueDate, setNewDueDate] = useState(null);
  const [isUpdatingDueDate, setIsUpdatingDueDate] = useState(false);

  const reminder = (_id) => {
    reminderApi(id, _id, dispatch)
  }

  const [startDateObj, setStartDateObj] = useState(null);
  const [endDateObj, setEndDateObj] = useState(null);

  // Update startDateObj and endDateObj whenever startDate or endDate change
  useEffect(() => {
    if (startDate) {
      setStartDateObj(new Date(startDate));
    }
    if (endDate) {
      setEndDateObj(new Date(endDate));
    }
  }, [startDate, endDate]);

  // Get status from URL query params
  const getStatusFromUrl = () => {
    const params = new URLSearchParams(location.search);
    return params.get('status') || "";
  };

  // Update URL when status changes
  const handleStatusFilter = (newStatus) => {
    const params = new URLSearchParams(location.search);
    if (newStatus) {
      params.set('status', newStatus);
    } else {
      params.delete('status');
    }
    history.push({
      pathname: location.pathname,
      search: params.toString()
    });
    setStatus(newStatus);
    setPage(1);
  };

  // Handle dropdown change
  const handleStatusDropdownChange = (e) => {
    handleStatusFilter(e.target.value);
  };

  // Sync status state with URL
  useEffect(() => {
    const urlStatus = getStatusFromUrl();
    if (urlStatus !== status) {
      setStatus(urlStatus);
    }
  }, []);

  useEffect(() => {
    if (id) {
      const urlStatus = getStatusFromUrl();
      // Use URL status if available, otherwise use state status
      const currentStatus = urlStatus || status;
      sentQuestionerDashboard(id, dispatch, page, search, startDate, endDate, currentStatus, pageSize, ids);
    }
  }, [id, page, search, startDate, endDate, status, pageSize, ids])

  useEffect(() => {
    if (id) {
      dashboardQuestionerTotal(id, dispatch);
    }
  }, [id])

  useEffect(() => {
    setTotalItems(data?.totalRecords)
  }, [data?.totalRecords])

  const clearFilters = () => {
    setSearch('');
    setStartDate('');
    setEndDate('');
    setStatus('');
    setPage(1);
  };


  // Add these new state variables
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const [tempStartDate, setTempStartDate] = useState(null);
  const [tempEndDate, setTempEndDate] = useState(null);

  // Update tempStartDate and tempEndDate whenever startDate or endDate change
  useEffect(() => {
    if (startDate) {
      setTempStartDate(new Date(startDate));
    }
    if (endDate) {
      setTempEndDate(new Date(endDate));
    }
  }, [startDate, endDate]);

  // Add this new function to format the displayed date range
  const formatDateRange = () => {
    if (startDate && endDate) {
      return `Selected date: ${startDate ? format(new Date(startDate), 'MM/dd/yyyy') : ''} to ${endDate ? format(new Date(endDate), 'MM/dd/yyyy') : ''}`;
    } else if (startDate) {
      return `From: ${startDate ? format(new Date(startDate), 'MM/dd/yyyy') : ''}`;
    } else if (endDate) {
      return `Till: ${endDate ? format(new Date(endDate), 'MM/dd/yyyy') : ''}`;
    }
    return "Select date range"; // Default placeholder text
  };

  // Add this function to handle applying the selected date range
  const applyDateRange = () => {
    if (tempStartDate) {
      setStartDate(format(tempStartDate, 'yyyy-MM-dd'));
    } else {
      setStartDate('');
    }

    if (tempEndDate) {
      setEndDate(format(tempEndDate, 'yyyy-MM-dd'));
    } else {
      setEndDate('');
    }

    setDatePickerOpen(false);
    setPage(1);
  };

  // Update the cancelDateSelection function to clear all dates
  const cancelDateSelection = () => {
    // Clear all date states when cancel is clicked
    setTempStartDate(null);
    setTempEndDate(null);
    setStartDate('');
    setEndDate('');
    setStartDateObj(null);
    setEndDateObj(null);
    setDatePickerOpen(false);
  };

  // Function to handle file selection
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Check if file is excel
      if (
        file.type === "application/vnd.ms-excel" ||
        file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        setSelectedFile(file);
        setUploadError("");
      } else {
        setUploadError("Please upload only Excel files (.xls or .xlsx)");
        setSelectedFile(null);
      }
    }
  };

  // Function to handle upload and process the file
  const handleUpload = async () => {
    if (!selectedFile) {
      setUploadError("Please select a file first");
      return;
    }

    setIsUploading(true);
    setUploadError("");

    try {
      const formData = new FormData();
      formData.append("questioner_form_excel", selectedFile);

      const response = await axios.post(
        `${API_URL}/tprm/66866ae9072369beb8721c48/answer-policy-questions-excel`,
        formData,
        {
          responseType: "blob",
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Create a download link for the response
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `questionnaire_responses_${new Date().toISOString().slice(0, 10)}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();

      // Close modal after successful download
      setAiModalOpen(false);
      setSelectedFile(null);
    } catch (error) {
      // console.error removed
      setUploadError("Error processing file. Please try again.");
    } finally {
      setIsUploading(false);
    }
  };

  // Open modal and pre-populate with existing emails
  const openResendModal = (questionnaire) => {
    setSelectedQuestionnaire(questionnaire);
    setResendEmails([...questionnaire.assignedUserEmails]);
    setNewEmail('');
    setResendError('');
    setResendModalOpen(true);
  };

  // Add a new email to the list
  const addEmailToResend = () => {
    if (!newEmail) return;

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(newEmail)) {
      setResendError('Please enter a valid email address');
      return;
    }

    // Check if email already exists in the list
    if (resendEmails.includes(newEmail)) {
      setResendError('This email is already in the list');
      return;
    }

    setResendEmails([...resendEmails, newEmail]);
    setNewEmail('');
    setResendError('');
  };

  // Remove an email from the list
  const removeEmailFromResend = (emailToRemove) => {
    setResendEmails(resendEmails.filter(email => email !== emailToRemove));
  };

  // Handle key press in email input (add on Enter)
  const handleEmailKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      addEmailToResend();
    }
  };

  // Submit the resend request
  const submitResendEmails = async () => {
    if (resendEmails.length === 0) {
      setResendError('Please add at least one email address');
      return;
    }

    setIsResending(true);
    setResendError('');

    try {
      const response = await axios.post(
        `${API_URL}/tprm/questioner/${selectedQuestionnaire._id}/resend`,
        { emails: resendEmails }
      );

      // Close modal on success
      setResendModalOpen(false);
      toastr.success('Success', 'Questionnaire resent successfully');

      // Refresh the data
      if (id) {
        sentQuestionerDashboard(id, dispatch, page, search, startDate, endDate, status, pageSize, ids);
      }
    } catch (error) {
      // console.error removed
      setResendError('Failed to resend questionnaire. Please try again.');
    } finally {
      setIsResending(false);
    }
  };

  // Function to open due date update modal
  const handleOpenDueDateModal = (vendorId, currentDueDate) => {
    setSelectedVendorId(vendorId);
    setNewDueDate(currentDueDate ? new Date(currentDueDate) : null);
    setDueDateModalOpen(true);
  };

  // Function to close due date update modal
  const handleCloseDueDateModal = () => {
    setDueDateModalOpen(false);
    setSelectedVendorId(null);
    setNewDueDate(null);
  };

  // Function to update due date
  const handleUpdateDueDate = async () => {
    if (!selectedVendorId || !newDueDate) {
      toastr.error("Error", "Please select a valid due date");
      return;
    }

    setIsUpdatingDueDate(true);
    const session = localStorage.getItem("session");

    try {
      const formattedDate = format(newDueDate, 'yyyy-MM-dd');
      const response = await axios.put(
        `${API_URL}/tprm/questioner/${selectedVendorId}/update-due-date`,
        { dueDate: formattedDate },
        {
          headers: {
            'Authorization': `Bearer ${session}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.data.error) {
        toastr.error("Error", response.data.userMessage || "Failed to update due date");
      } else {
        toastr.success("Success", response.data.userMessage || "Due date updated successfully");
        // Refresh the data
        if (id) {
          const urlStatus = getStatusFromUrl();
          const currentStatus = urlStatus || status;
          sentQuestionerDashboard(id, dispatch, page, search, startDate, endDate, currentStatus, pageSize, ids);
        }
        handleCloseDueDateModal();
      }
    } catch (error) {
      let errorMessage = "Failed to update due date";
      if (error.response?.data?.userMessage) {
        errorMessage = error.response.data.userMessage;
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      }
      toastr.error("Error", errorMessage);
    } finally {
      setIsUpdatingDueDate(false);
    }
  };

  return (
    <div className="container-fluid risk-dashboard">
      <div className="block-header">
        <div className="row clearfix">
          <div className="col-md-6 col-sm-12">
            <h1 className="welcome-text">Third Party Risk Management</h1>
            <nav aria-label="breadcrumb" className="mt-1">
              <ol className="breadcrumb d-flex align-items-center m-0">
                <li className="breadcrumb-item">
                  <Link to="/vendor" className="text-black">Third Party Risk Management</Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to="/tprm/assessment-campaign" className="text-black">Assessment Campaign</Link>
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="body">
          {/* Status Cards */}
          <div className="row mb-2">
            <div className="col-md-12">
              <div className="d-flex flex-wrap align-items-center w-100 gap-3">
                <div className={`stat-card${status === 'sent' ? ' active' : ''}`} onClick={() => handleStatusFilter('sent')}>
                  <div className="mr-3 d-flex align-items-center">
                    <div className="icon-container mr-3">{icons.sent}</div>
                    <div>
                      <span className="d-block h4 mb-0 font-weight-bold">{totalCount?.totalQuestionerForms}</span>
                      <span className="text-muted">Sent</span>
                    </div>
                  </div>
                </div>
                <div className={`stat-card${status === 'unseen' ? ' active' : ''}`} onClick={() => handleStatusFilter('unseen')}>
                  <div className="mr-3 d-flex align-items-center">
                    <div className="icon-container mr-3">{icons.unseen}</div>
                    <div>
                      <span className="d-block h4 mb-0 font-weight-bold">{totalCount?.unseenQuestionerForms || 0}</span>
                      <span className="text-muted">Unseen</span>
                    </div>
                  </div>
                </div>
                <div className={`stat-card${status === 'submitted' ? ' active' : ''}`} onClick={() => handleStatusFilter('submitted')}>
                  <div className="mr-3 d-flex align-items-center">
                    <div className="icon-container mr-3">{icons.inReview}</div>
                    <div>
                      <span className="d-block h4 mb-0 font-weight-bold">{totalCount?.submittedQuestionerForms}</span>
                      <span className="text-muted">Still in review</span>
                    </div>
                  </div>
                </div>
                <div className={`stat-card${status === 'complete' ? ' active' : ''}`} onClick={() => handleStatusFilter('complete')}>
                  <div className="mr-3 d-flex align-items-center">
                    <div className="icon-container mr-3">{icons.complete}</div>
                    <div>
                      <span className="d-block h4 mb-0 font-weight-bold">{totalCount?.totalApprovedQuestionerForms || 0}</span>
                      <span className="text-muted">Complete</span>
                    </div>
                  </div>
                </div>
                <div className={`stat-card${status === 'overdue' ? ' active' : ''}`} onClick={() => handleStatusFilter('overdue')}>
                  <div className="mr-3 d-flex align-items-center">
                    <div className="icon-container mr-3">{icons.overdue}</div>
                    <div>
                      <span className="d-block h4 mb-0 font-weight-bold">{totalCount?.totalPastDueQuestionerForms}</span>
                      <span className="text-muted">Overdue</span>
                    </div>
                  </div>
                </div>
                <div className={`stat-card${status === 'rejected' ? ' active' : ''}`} onClick={() => handleStatusFilter('rejected')}>
                  <div className="mr-3 d-flex align-items-center">
                    <div className="icon-container mr-3">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="currentColor" strokeWidth="1.5" />
                        <path d="M9 15L15 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M15 15L9 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </div>
                    <div>
                      <span className="d-block h4 mb-0 font-weight-bold">{totalCount?.totalRejectedQuestionerForms}</span>
                      <span className="text-muted">Rejected</span>
                    </div>
                  </div>
                </div>
                <div className={`stat-card${status === 'incomplete' ? ' active' : ''}`} onClick={() => handleStatusFilter('incomplete')}>
                  <div className="mr-3 d-flex align-items-center">
                    <div className="icon-container mr-3">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="currentColor" strokeWidth="1.5" />
                        <path d="M8 12H16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </div>
                    <div>
                      <span className="d-block h4 mb-0 font-weight-bold">{totalCount?.totalIncompleteQuestionerForms}</span>
                      <span className="text-muted">Incomplete</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Filter row: Search, Date Range, Status Dropdown below the cards */}
          <div className="row mb-4">
            <div className="col-md-3">
              <div className="searchBoxInput p-0 mx-1">
                <input
                  className="form-control form-control-sm"
                  type="text"
                  placeholder="Questionnaire Search"
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value)
                    setPage(1)
                  }}
                />
              </div>
            </div>

            <div className="col-sm-3">
              <div className="date-picker-container">
                <div className="date-range-input">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Select date range"
                    value={formatDateRange()}
                    onClick={() => setDatePickerOpen(true)}
                    readOnly
                  />
                  <span className="calendar-icon">
                    <i className="fa fa-calendar" aria-hidden="true"></i>
                  </span>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <select
                className="form-control"
                value={status}
                onChange={handleStatusDropdownChange}
              >
                <option value="">All Status</option>
                <option value="sent">Sent</option>
                <option value="unseen">Unseen</option>
                <option value="submitted">In Review</option>
                <option value="complete">Complete</option>
                <option value="overdue">Overdue</option>
                <option value="rejected">Rejected</option>
                <option value="incomplete">Incomplete</option>
              </select>
            </div>
          </div>
          <div className="table-responsive table-risk mt-3">
            <table className="table table-custom spacing5 mb-0">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Questionnaire Used</th>
                  <th>Due Date</th>
                  <th>Created At</th>
                  <th>Vendor</th>
                  <th>Status</th>
                  <th>Completion %</th>
                  <th>Risks</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {data?.data?.map((vendor, index) => (
                  <tr key={vendor?._id}>
                    <td>{vendor?._id}</td>
                    <td>{vendor?.formTitle}</td>
                    <td>
                      <div className="d-flex align-items-center">
                        {moment(vendor?.dueDate).isBefore(moment()) ? (
                          <span className="overdue-date d-flex align-items-center">
                            <svg
                              className="mr-1"
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#dc3545"
                              strokeWidth="2"
                            >
                              <circle cx="12" cy="12" r="10" />
                              <line x1="12" y1="8" x2="12" y2="12" />
                              <line x1="12" y1="16" x2="12" y2="16" />
                            </svg>
                            <span style={{ color: '#dc3545', fontWeight: '500' }}>
                              {moment(vendor?.dueDate).format("DD-MM-YYYY")} (Overdue)
                            </span>
                          </span>
                        ) : (
                          <span>
                            {moment(vendor?.dueDate).format("DD-MM-YYYY")}
                          </span>
                        )}
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            handleOpenDueDateModal(vendor?._id, vendor?.dueDate);
                          }}
                          className="btn btn-sm btn-link p-0 ml-2"
                          style={{ 
                            color: '#453acd',
                            textDecoration: 'none',
                            minWidth: 'auto',
                            padding: '2px 4px'
                          }}
                          title="Edit Due Date"
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                          </svg>
                        </button>
                      </div>
                    </td>
                    <td>
                      {moment(vendor?.createdAt).format("DD-MM-YYYY")}
                    </td>
                    <td>
                      <Link to={`/tprm/vendor/${vendor?.assigneeOrganisationId}`}>{vendor?.assigneeOrganisation}</Link>
                    </td>
                    <td>
                      {vendor?.status === "pending" ? (
                        <span className="status-text status-pending d-flex align-items-center">
                          <svg className="stat-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <circle cx="12" cy="12" r="10"></circle>
                            <polyline points="12 6 12 12 16 14"></polyline>
                          </svg>
                          <span className="ml-2">Pending</span>
                        </span>
                      ) : vendor?.status === "unseen" ? (
                        <span className="status-text status-unseen d-flex align-items-center">
                          <svg className="stat-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                            <circle cx="12" cy="12" r="3"></circle>
                          </svg>
                          <span className="ml-2">Unseen</span>
                        </span>
                      ) : vendor?.status === "seen" ? (
                        <span className="status-text status-seen d-flex align-items-center">
                          <svg className="stat-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M22 2L11 13"></path>
                            <path d="M22 2l-7 20-4-9-9-4 20-7z"></path>
                          </svg>
                          <span className="ml-2">Seen</span>
                        </span>
                      ) : vendor?.status === "rejected" ? (
                        <span className="status-text status-rejected d-flex align-items-center">
                          <svg className="stat-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="15" y1="9" x2="9" y2="15"></line>
                            <line x1="9" y1="9" x2="15" y2="15"></line>
                          </svg>
                          <span className="ml-2">Rejected</span>
                        </span>
                      ) : vendor?.status === "approved" ? (
                        <span className="status-text status-approved d-flex align-items-center">
                          <svg className="stat-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M20 7L12 4L4 7V11C4 14.3137 6.46819 18.4411 11.9999 20C17.5318 18.4411 20 14.3137 20 11V7Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                          <span className="ml-2">Approved</span>
                        </span>
                      ) : vendor?.status === "submitted" ? (
                        <span className="status-text status-submitted d-flex align-items-center">
                          <svg className="stat-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" />
                          </svg>
                          <span className="ml-2">Submitted</span>
                        </span>
                      ) : vendor?.status === "incomplete" ? (
                        <span className="status-text status-incomplete d-flex align-items-center">
                          <svg className="stat-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M8 12H16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                          <span className="ml-2">Incomplete</span>
                        </span>
                      ) : "N/A"}
                    </td>
                    <td>
                      <div className="d-flex align-items-center">
                        <div className="progress" style={{ width: '100px', height: '8px' }}>
                          <div
                            className="progress-bar"
                            role="progressbar"
                            style={{
                              width: `${vendor?.percentageOfRespondedQuestions || 0}%`,
                              backgroundColor: vendor?.percentageOfRespondedQuestions === 100 ? '#28a745' : '#007bff'
                            }}
                            aria-valuenow={vendor?.percentageOfRespondedQuestions || 0}
                            aria-valuemin="0"
                            aria-valuemax="100"
                          ></div>
                        </div>
                        <span className="ml-2">{vendor?.percentageOfRespondedQuestions?.toFixed(1) || 0}%</span>
                      </div>
                    </td>
                    <td>
                      <div className="d-flex flex-column">
                        {vendor?.riskRegisterInfo && (
                          <div className="risk-stats">
                            <div className="risk-stat-item">
                              <span className="risk-badge critical">
                                {vendor.riskRegisterInfo.totalCriticalRisks || 0}
                              </span>
                              <span className="risk-label">Critical</span>
                            </div>
                            <div className="risk-stat-item">
                              <span className="risk-badge high">
                                {vendor.riskRegisterInfo.totalHighRisks || 0}
                              </span>
                              <span className="risk-label">High</span>
                            </div>
                            <div className="risk-stat-item">
                              <span className="risk-badge medium">
                                {vendor.riskRegisterInfo.totalMediumRisks || 0}
                              </span>
                              <span className="risk-label">Medium</span>
                            </div>
                            <div className="risk-stat-item">
                              <span className="risk-badge low">
                                {vendor.riskRegisterInfo.totalLowRisks || 0}
                              </span>
                              <span className="risk-label">Low</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </td>
                    <td>
                      <div className="d-flex align-items-center gap-2">
                        {(moment(vendor?.dueDate).isBefore(moment()) && (vendor?.status !== 'complete' && vendor?.status !== 'submitted') || vendor?.status === 'unseen') && (
                          <button
                            onClick={() => reminder(vendor?._id)}
                            className="btn btn-sm d-flex align-items-center reviewButton"
                          >
                            <svg
                              className="mr-1"
                              width="14"
                              height="14"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                            >
                              <path d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"></path>
                            </svg>
                            Remind
                          </button>
                        )}

                        {/* Add Resend button */}
                        <button
                          onClick={() => openResendModal(vendor)}
                          className="btn btn-sm d-flex align-items-center reviewButton"
                        >
                          <svg
                            className="mr-1"
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                          >
                            <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                            <circle cx="8.5" cy="7" r="4" />
                            <line x1="20" y1="8" x2="20" y2="14" />
                            <line x1="23" y1="11" x2="17" y2="11" />
                          </svg>
                          Add Users
                        </button>

                        {(vendor?.status === 'in_review' ||
                          vendor?.status === 'complete' ||
                          vendor?.status === 'submitted' ||
                          vendor?.status === 'approved' ||
                          vendor?.status === 'rejected') && (
                            <Link
                              to={`review-risk/${vendor?._id}`}
                              style={{ backgroundColor: '#08283f' }}
                              className="btn btn-sm d-flex align-items-center reviewButton"
                            >
                              <svg
                                className="mr-1"
                                width="14"
                                height="14"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                              >
                                <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                              </svg>
                              Review
                            </Link>
                          )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="dataTables_paginate d-flex align-items-center justify-content-between">
            {totalItems > 0 && (
              <Pagination
                className="pagination-bar"
                currentPage={page}
                totalCount={totalItems}
                pageSize={pageSize}
                onPageChange={(page) => setPage(page)}
              />
            )}
            <div className="d-flex align-items-center">
              {totalItems > 10 && (
                <select
                  className="form-control form-control-sm"
                  style={{ width: '70px' }}
                  value={pageSize}
                  onChange={(e) => {
                    setPageSize(Number(e.target.value));
                    setPage(1);
                  }}
                >
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
              )}
            </div>
          </div>
        </div>
      </div>
      {datePickerOpen && (
        <div className="date-range-overlay" onClick={() => setDatePickerOpen(false)}>
          <div className="date-range-picker-popup" onClick={(e) => e.stopPropagation()}>
            <div className="date-range-picker-header">
              {tempStartDate && tempEndDate
                ? `Selected date: ${format(tempStartDate, 'MM/dd/yyyy')} to ${format(tempEndDate, 'MM/dd/yyyy')}`
                : "Select date range"}
            </div>
            <div className="date-range-calendars">
              <div>
                <h6>From</h6>
                <DatePicker
                  selected={tempStartDate}
                  onChange={(date) => {
                    setTempStartDate(date);
                    if (tempEndDate && date > tempEndDate) {
                      setTempEndDate(null);
                    }
                  }}
                  selectsStart
                  startDate={tempStartDate}
                  endDate={tempEndDate}
                  inline
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />
              </div>
              <div>
                <h6>To</h6>
                <DatePicker
                  selected={tempEndDate}
                  onChange={(date) => setTempEndDate(date)}
                  selectsEnd
                  startDate={tempStartDate}
                  endDate={tempEndDate}
                  minDate={tempStartDate}
                  inline
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />
              </div>
            </div>
            <div className="date-range-actions">
              <button
                className="date-range-apply"
                onClick={applyDateRange}
              >
                Apply Filter
              </button>
              <button
                className="date-range-cancel"
                onClick={cancelDateSelection}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* AI Questionnaire Modal */}
      {aiModalOpen && (
        <div className="modal-overlay" onClick={() => setAiModalOpen(false)} style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{
            width: '500px',
            backgroundColor: '#fff',
            borderRadius: '8px',
            padding: '20px',
            boxShadow: '0 5px 15px rgba(0,0,0,0.2)'
          }}>
            <div className="modal-header d-flex justify-content-between align-items-center mb-1">
              <h5 className="m-0">Questionnaire AI Assistant</h5>
              <button
                className="close-btn"
                onClick={() => setAiModalOpen(false)}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '20px',
                  cursor: 'pointer'
                }}
              >
                &times;
              </button>
            </div>
            <div className="modal-body">
              <p>Upload your Excel file with questionnaire data to get AI-powered responses.</p>

              <div className="form-group mt-3">
                <label className="d-block p-2" style={{
                  border: '2px dashed #ccc',
                  borderRadius: '5px',
                  textAlign: 'center',
                  padding: '20px',
                  cursor: 'pointer',
                  marginBottom: '15px'
                }}>
                  <input
                    type="file"
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                    accept=".xls,.xlsx"
                  />
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#888"
                    strokeWidth="2"
                    style={{ display: 'block', margin: '0 auto 10px' }}
                  >
                    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                    <polyline points="17 8 12 3 7 8" />
                    <line x1="12" y1="3" x2="12" y2="15" />
                  </svg>
                  {selectedFile ? selectedFile.name : "Click to browse or drop Excel file here"}
                </label>

                {uploadError && (
                  <div className="alert alert-danger py-2" role="alert">
                    {uploadError}
                  </div>
                )}

                {selectedFile && (
                  <div className="selected-file d-flex align-items-center justify-content-between p-2 bg-light rounded">
                    <span className="text-truncate" style={{ maxWidth: '300px' }}>
                      {selectedFile.name}
                    </span>
                    <button
                      className="btn btn-sm btn-light p-0"
                      style={{ maxWidth: "20px", minWidth: "20px" }}
                      onClick={() => setSelectedFile(null)}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                      </svg>
                    </button>
                  </div>
                )}
              </div>
            </div>
            <div className="modal-footer d-flex justify-content-end mt-3">
              <button
                className="btn btn-round btn-default mr-2"
                onClick={() => setAiModalOpen(false)}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={handleUpload}
                disabled={!selectedFile || isUploading}
                style={{
                  backgroundColor: '#08283f',
                  border: 'none'
                }}
              >
                {isUploading ? (
                  <>
                    {/* <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span> */}
                    Processing...
                  </>
                ) : (
                  "Upload & Process"
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Update Due Date Modal */}
      {dueDateModalOpen && (
        <div className="modal-overlay" onClick={handleCloseDueDateModal} style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{
            width: '400px',
            backgroundColor: '#fff',
            borderRadius: '8px',
            padding: '20px',
            boxShadow: '0 5px 15px rgba(0,0,0,0.2)'
          }}>
            <div className="modal-header d-flex justify-content-between align-items-center mb-3">
              <h5 className="m-0">Update Due Date</h5>
              <button 
                className="close-btn"
                onClick={handleCloseDueDateModal}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '20px',
                  cursor: 'pointer'
                }}
              >
                &times;
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label className="mb-2 d-block">Select New Due Date</label>
                <DatePicker
                  selected={newDueDate}
                  onChange={(date) => setNewDueDate(date)}
                  minDate={new Date()}
                  dateFormat="MM/dd/yyyy"
                  className="form-control form-control-sm"
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  placeholderText="Select due date"
                  isClearable
                />
              </div>
            </div>
            <div className="modal-footer d-flex justify-content-end mt-3">
              <button
                className="btn btn-round btn-default mr-2"
                onClick={handleCloseDueDateModal}
                disabled={isUpdatingDueDate}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={handleUpdateDueDate}
                disabled={!newDueDate || isUpdatingDueDate}
                style={{
                  backgroundColor: '#453acd',
                  border: 'none'
                }}
              >
                {isUpdatingDueDate ? "Updating..." : "Update Due Date"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Resend Email Modal */}
      {resendModalOpen && selectedQuestionnaire && (
        <div className="modal-overlay" onClick={() => setResendModalOpen(false)} style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{
            width: '500px',
            backgroundColor: '#fff',
            borderRadius: '8px',
            padding: '20px',
            boxShadow: '0 5px 15px rgba(0,0,0,0.2)'
          }}>
            <div className="modal-header d-flex justify-content-between align-items-center mb-3">
              <h5 className="modal-title">Resend Questionnaire</h5>
              <button
                className="close-btn"
                onClick={() => setResendModalOpen(false)}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '20px',
                  cursor: 'pointer'
                }}
              >
                &times;
              </button>
            </div>

            <div className="modal-body">
              <div className="form-group">
                <label>Recipients</label>
                <div className="d-flex align-items-center mb-2">
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Enter email address"
                    value={newEmail}
                    onChange={(e) => setNewEmail(e.target.value)}
                    onKeyPress={handleEmailKeyPress}
                  />
                  <button
                    className="btn btn-sm btn-primary ml-2"
                    onClick={addEmailToResend}
                    style={{
                      backgroundColor: '#08283f',
                      border: 'none',
                      minWidth: '60px'
                    }}
                  >
                    Add
                  </button>
                </div>

                {resendError && (
                  <div className="alert alert-danger py-2 mb-3" role="alert">
                    {resendError}
                  </div>
                )}

                <div className="email-list mt-3">
                  {resendEmails.length > 0 ? (
                    <div className="d-flex flex-wrap">
                      {resendEmails.map((email, index) => (
                        <div className="m-1" key={index}>
                          <label className="labelClientAdd">
                            <span>
                              {email}{" "}
                              <span
                                className="fa fa-times-circle"
                                onClick={() => removeEmailFromResend(email)}
                              ></span>
                            </span>
                          </label>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="alert alert-warning py-2">
                      No recipients added. Please add at least one email address.
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="modal-footer d-flex justify-content-end mt-3">
              <button
                className="btn btn-round btn-default mr-2"
                onClick={() => setResendModalOpen(false)}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={submitResendEmails}
                disabled={resendEmails.length === 0 || isResending}
                style={{
                  backgroundColor: '#08283f',
                  border: 'none'
                }}
              >
                {isResending ? (
                  <>
                    <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                    Sending...
                  </>
                ) : (
                  "Resend Questionnaire"
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RiskManagement;
